import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, RouteComponentProps} from 'react-router-dom';
import {Button, Col, Label, Row, Table} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {hasAnyPermission} from 'app/shared/auth/permissions';
import {IRootState} from 'app/shared/reducers';
import {getEntities} from './condition.reducer';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {IRegion} from "app/shared/model/region.model";
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';

export interface IconditionProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {
}

export const Condition = (props: IconditionProps) => {
  const emptyRegion: IRegion = null
  const {conditionList, match, loading, userCountryId} = props;
  const [activeCountry, setActiveCountry] = useState<IRegion>({})
  const [conditionsPerCountry, setConditionPerCountry] = useState([])
  const [selectedEmergencyType, setSelectedEmergencyType] = useState('');
  const [selectedFollowupType, setSelectedFollowupType] = useState('');

  useEffect(() => {
    props.getEntities();
  }, []);

  useEffect(() => {
    const ac = props.countries.find(country => country.id === userCountryId)
    setActiveCountry(ac)
  }, [props.countries, userCountryId]);

  const updateSymptomList = (ac) => {
    setConditionPerCountry(conditionList.filter(condition => condition.countryId && condition.countryId === ac.id))
  }

  useEffect(() => {
    if (conditionList && activeCountry) {
      updateSymptomList(activeCountry)
    }
  }, [conditionList]);

  const filteredConditions = conditionsPerCountry.filter(condition => {
    const matchesEmergencyType = !selectedEmergencyType || condition.emergencyType === selectedEmergencyType;
    const matchesFollowupType = !selectedFollowupType || condition.followupType === selectedFollowupType;
    return matchesEmergencyType && matchesFollowupType;
  });

  const onCountryChange = (event) => {
    const countryId = event.target.value
    const newActiveCountry = props.countries.find(country => country.id === countryId)
    setActiveCountry(newActiveCountry)
    setSelectedEmergencyType('');
    setSelectedFollowupType('');
    updateSymptomList(newActiveCountry)
  }
  const regCountriesList = props.countries.filter((ele) => {
    return props.isAdmin ? 1 : ele.id === activeCountry?.id;
  })

  return (
    <div>
      <Row>
        <Col md="6">
          <h2 id="condition-heading">Conditions</h2>
        </Col>
        <Col md="6">
          {(activeCountry && typeof activeCountry.id !== 'undefined') && (
            <Link to={`${match.url}/new?country_id=${activeCountry.id}`}
                  className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
              <FontAwesomeIcon icon="plus"/>
              &nbsp; Create new Condition
            </Link>
          )}
        </Col>
      </Row>
      <br/>
      <AvForm model={{}}>
        <Row>
          {activeCountry && (
            <Col md="12">
              <AvGroup>
                <Label for="condition-countries">Country</Label>
                <AvInput id="condition-countries" type="select" className="form-control" name="condition-country"
                         value={activeCountry.id} onChange={onCountryChange}>
                  {regCountriesList
                    ? regCountriesList.map(country => (
                      <option value={country.id} key={country.id}>
                        {country.name}
                      </option>
                    ))
                    : null}
                </AvInput>
              </AvGroup>
            </Col>
          )}
          <Col md="6">
            <AvGroup>
              <Label for="condition-followup-type">Condition Type</Label>
              <AvInput
                id="condition-followup-type"
                type="select"
                className="form-control"
                name="condition-followup-type"
                value={selectedFollowupType}
                onChange={e => setSelectedFollowupType(e.target.value)}
              >
                <option value="">All Condition Types</option>
                <option value="MATERNAL">MATERNAL</option>
                <option value="NEONATAL">NEONATAL</option>
              </AvInput>
            </AvGroup>
          </Col>
          <Col md="6">
            <AvGroup>
              <Label for="condition-emergency-type">Emergency Type</Label>
              <AvInput
                id="condition-emergency-type"
                type="select"
                className="form-control"
                name="condition-emergency-type"
                value={selectedEmergencyType}
                onChange={e => setSelectedEmergencyType(e.target.value)}
              >
                <option value="">All Emergency Types</option>
                {Object.values(EmergencyType).map(type => (
                  <option value={type} key={type}>{type}</option>
                ))}
              </AvInput>
            </AvGroup>
          </Col>
        </Row>
      </AvForm>
      <br/>

      <div className="table-responsive">
        {filteredConditions && filteredConditions.length > 0 ? (
          <Table responsive>
            <thead>
            <tr>
              <th>Condition Type</th>
              <th>Emergency Type</th>
              <th>Condition (English)</th>
              <th>Condition (Local Language)</th>
              <th>IsAlive</th>
              <th>Delivered</th>
              <th>Status</th>
              <th>Parent Followup</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            {filteredConditions.map((condition, i) => (
              <tr key={`entity-${i}`}>
                <td>{condition.followupType}</td>
                <td>{condition?.emergencyType}</td>
                <td>{condition.enFollowup}</td>
                <td>{condition.stFollowup}</td>
                <td>{condition.isAlive ? 'Yes' : 'No'}</td>
                <td>{condition.isDelivered ? 'Yes' : condition.isDelivered === null ? 'Null' : 'No'}</td>
                <td>{condition.isActive ? 'Active' : 'Inactive'}</td>
                <td>{condition.parent ? condition.parent.enFollowup : '-'}</td>
                <td className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${condition.id}`} color="info" size="sm">
                      <FontAwesomeIcon icon="eye"/> <span className="d-none d-md-inline">View</span>
                    </Button>
                    <Button tag={Link} to={`${match.url}/${condition.id}/edit`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt"/> <span className="d-none d-md-inline">Edit</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Conditions found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({condition, authentication}: IRootState) => ({
  conditionList: condition.conditionList,
  loading: condition.loading,
  countries: condition.countries,
  userCountryId: authentication.userCountryId,
  isAdmin: hasAnyPermission(authentication.account.roles, ['ADMIN'])
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Condition);
